import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { Buttoms, DefaultListOrder } from '../../../private/shared/models/order-list';

@Component({
  selector: 'range-input',
  templateUrl: './range-input.component.html',
  styleUrls: ['./range-input.component.scss'],
})
export class RangeInputComponent implements OnInit, OnChanges {

  @Input() initial = 0
  @Input() configurations?: Buttoms = DefaultListOrder.componentContent.range.buttoms
  @Input() warningSelector = false;

  @Output() comeBack = new EventEmitter<number>()
  @Output() changeEventType = new EventEmitter<string>()

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('initial') && changes.initial.previousValue === undefined && changes.initial.currentValue === this.initial) {
      this.comeBack.next(changes.initial.currentValue);
    }
  }

  public validated(range: number) {
    const parse = range.toString() === '' ? 0 : Number(range)
    this.initial = parse > this.configurations.end ? this.configurations.end : parse
  }

  public onAdd() {
    if (this.initial === this.configurations.end) return;
    this.initial += 1
    this.comeBack.next(this.initial)
    this.changeEventType.emit('add');
  }

  public onRemove() {
    if (this.initial === this.configurations.initial) return;
    this.initial -= 1
    this.comeBack.next(this.initial)
    this.changeEventType.emit('remove');
  }


}
